import { FC } from 'react';
// Mui
import { Box } from '@mui/material';
// 
import InvoicesSummary from './InvoicesSummary';
import SummaryTable from './DashboardTable';

const DashboardTabContent:FC = () => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <InvoicesSummary />
      <Box sx={{ height: 'calc(100% - 64px)', p: 8 }}>
        <SummaryTable />
      </Box>
    </Box>
  )
}

export default DashboardTabContent;
